<template>
    <div>
        <!-- Header section -->
        <header class="header-section">
            <div class="container text-right">
                <div class="page-info">
                    <h2>Интересни случаи</h2>
                    <div class="page-links">
                        <router-link to="/">Начало</router-link>
                        <span class="active">Интересни случаи</span>
                    </div>
                </div>
            </div>
        </header>
        <!-- Header section end -->

        <div class="container mt-5">
            <div class="row">
                <div class="col-md-12 border-bottom row mb-5 pb-5">
                    <div class="col-md-1">.</div>
                    <div class="col-md-10">
                        <h2>{{ interesting.name }}</h2>
                        <p><i class="fa fa-calendar"></i> {{ interesting.createdAt | formatDate }}</p>
                        <router-link v-if="userLogedIn" class="btn-lg btn-primary" :to="{name: 'interestingEdit', params: { id: $route.params.id }}">РЕДАКТИРАНЕ</router-link>
                        <div class="news-image-container mt-3">
                            <img :src="interesting.image" alt="" class="card-img-top">                        </div>
                        <p class="mt-4" v-html="interesting.description"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { db } from '../../firebase';

    export default {
        data() {
            return {
                interesting: {
                }
            }
        },
        computed: {
            userLogedIn () {
                return this.$store.getters.user
            }
        },
        created() {
            let dbRef = db.collection('interesting').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.interesting = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        }
    }
</script>
